
import PhotoSwipe from 'components/photoswipe';
import PhotoSwipeLightbox from 'components/photoswipe-lightbox';

const MobileLightbox = new PhotoSwipeLightbox({
  gallery: '[id^="Product-gallery-"]',
  children: 'a[itemprop="contentUrl"]',
  wheelToZoom: true,
  pswpModule: () => import('components/photoswipe'),
  allowPanToNext: false
});

MobileLightbox.init();